
function Header() {



  return (
    <>
      <div className="bg-blue">
        {/* <div className="d-flex border-gris">
            <div className='mb-2 mt-4 text-gris '>Blog</div>
          </div> */}
        <div className="container">
          <div className="d-flex justify-content-between py-3">
            <div className="text-between text-bold text-white">La Verdad Minera</div>
            <div className="text-white">Blog</div>
          </div>
        </div>
      </div>
    </>

  )
}

export default Header